import { Box } from "@mui/material";
import { useFeatureMedia } from "../utils/useFeatureMedia";

import Heading from "../Heading";
import { getSummaryStyles } from "./styles";

interface IProps {
  title: string;
  isActive: boolean;
}
const FeatureSummary: React.FC<IProps> = ({ title, isActive }) => {
  const { isLargeScreen } = useFeatureMedia();

  return (
    <Box sx={getSummaryStyles(isActive, isLargeScreen)}>
      <Heading title={title} />
    </Box>
  );
};

export default FeatureSummary;
